(function() {
	'use strict';

	angular.module('app.leanProjects')
		.directive('generalSection', generalSection);

	generalSection.$inject = ['$rootScope'];

	function generalSection($rootScope) {
		return {
			restrict: 'EA',
			templateUrl: '/application/f/lean-projects/projects/general-section.html',
			scope: {
				projectNdx: '@projectNdx',
				leanDirFactoryNdx: '@leanDirFactoryNdx',
				details: '=',
				userRoles: '@userRoles',
				currencySymbol: '@currencySymbol'
			},
			controller: generalSectionController,
			controllerAs: 'generalSectionController',
			bindToController: true
		};
	}

	generalSectionController.$inject = ['$scope', '$rootScope', '$uibModal', '$compile', '$filter', 'editProjectService', 'viewProjectsService', 'leanProjectAuthService', 'leanProjectsService', '$translate'];
	function generalSectionController($scope, $rootScope, $uibModal, $compile, $filter, editProjectService, viewProjectsService, leanProjectAuthService, leanProjectsService, $translate) {
		var vm = this;
		vm.loading = {'details': true};
		vm.customFields = [];
		vm.customAreaFields = [];
		vm.showEditText = showEditText;
		vm.showEditTextArea = showEditTextArea;
		vm.showEditDate = showEditDate;
		vm.showEditList = showEditList;
		vm.showMultiselectList = showMultiselectList;
		vm.saveEditList = saveEditList;
		vm.saveEditText = saveEditText;
		vm.saveEditDate = saveEditDate;
		vm.cancelEdit = cancelEdit;
		vm.actionIsAllowed = actionIsAllowed;
		vm.currentText = '';
		vm.dropdownLists = {};
		vm.noGoalsDefined = false;
		this.$onInit = function () {
			if (globalConfig.user.role !== 'Supplier') {
				getGoals();
			}
			leanProjectsService.getCustomFieldList().then(function (customFields) {
				//vm.customFields = customFields;
				var customAreaFields = [];
				for (var i = customFields.length - 1; i >= 0; i--) {
					if (customFields[i].fieldType === 'TEXTAREA') {
						customAreaFields.push(customFields[i]);
						customFields.splice(i, 1);
					}
				}
				vm.customFields = customFields;
				vm.customAreaFields = customAreaFields;
				getProjectGeneralDetails();
			});
		};
		

		function actionIsAllowed(action) {
			return leanProjectAuthService.actionIsAllowed(action, vm.details);
		}

		function getProjectGeneralDetails() {
			editProjectService.getGeneral(vm.projectNdx, vm.leanDirFactoryNdx).then(function(generalDetails) {
				vm.details = jQuery.extend({}, vm.details, generalDetails);
				vm.loading.details = false;
				updateGoalModel();
			});
		}

		function showEditText(field, label, customFieldNdx, customFieldType) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var cell = jQuery('#' + field);
			var pos = cell.offset();
			var content = vm.details[field];
			var editTemplate = getTextTemplate(pos, field, label, customFieldNdx, customFieldType);
			if (typeof customFieldType !== 'undefined'  && content != '' && (customFieldType == 'NUMBER' || customFieldType == 'CURRENCY')){
				content = parseFloat(content);
			}
			vm.currentText = content;
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('#mainView .embeddedBody').append(compiledDiv);
			compiledDiv.keyup(function(event) {
				var code = event.keyCode || event.which;
				if (code === 13) {
					vm.saveEditText(field, label, customFieldNdx, customFieldType);
				} else if (code === 27) {
					vm.cancelEdit();
				}
			});
			jQuery('.inlineEditDiv input').focus();
			vm.inlineActive = true;
		}

		function showEditTextArea(field, label, customFieldNdx, customFieldType) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var cell = jQuery('#' + field);
			var pos = cell.offset();
			var content = vm.details[field];
			var editTemplate = getTextAreaTemplate(pos, field, label, customFieldNdx, customFieldType);
			vm.currentText = content;
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('#mainView .embeddedBody').append(compiledDiv);
			compiledDiv.keyup(function(event) {
				var code = event.keyCode || event.which;
				if (code === 27) {
					vm.cancelEdit();
				}
			});
			jQuery('.inlineEditDiv input').focus();
			vm.inlineActive = true;
		}

		function showEditDate(field, label, customFieldNdx, customFieldType, showClear) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var cell = jQuery('#' + field);
			var pos = cell.offset();
			var content = vm.details[field];

			var editTemplate = getDateTemplate(pos, field, label, customFieldNdx, customFieldType, showClear);
			vm.currentDate = content;
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('#mainView .embeddedBody').append(compiledDiv);
			compiledDiv.keyup(function(event) {
				var code = event.keyCode || event.which;
				if (code === 13) {
					vm.saveEditDate(field, label, customFieldNdx, customFieldType);
				} else if (code === 27) {
					vm.cancelEdit();
				}
			});
			jQuery('.inlineEditDiv input').focus();
			vm.inlineActive = true;
		}

		function showMultiselectList(field, fieldId, label, id, display) {
			loadList(field);
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var cell = jQuery('#' + field);
			var pos = cell.offset();
			var editTemplate = getMultiselectTemplate(pos, field, fieldId, escapeSingleQoute(label), id, display);
			vm.modelName = vm.details[fieldId];
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('#mainView .embeddedBody').append(compiledDiv);
			compiledDiv.keyup(function(event) {
				var code = event.keyCode || event.which;
				if (code === 27) {
					vm.cancelEdit();
				}
			});
			jQuery('.inlineEditDiv input').focus();
			vm.inlineActive = true;
		}

		function showEditList(field, fieldId, label, id, display, customFieldNdx, customFieldType, translate, showClear) {
			loadList(field, customFieldNdx);
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var cell = jQuery('#' + field);
			var pos = cell.offset();
			var editTemplate;
			editTemplate = getListTemplate(pos, field, fieldId, label, id, display, customFieldNdx, customFieldType, translate, showClear);
			vm.currentListOption = vm.details[fieldId];
			var compiledDiv = $compile(editTemplate)($scope);
			jQuery('#mainView .embeddedBody').append(compiledDiv);
			compiledDiv.keyup(function(event) {
				var code = event.keyCode || event.which;
				if (code === 13) {
					vm.saveEditList(field, fieldId, label, id, display, customFieldNdx, customFieldType);
				} else if (code === 27) {
					vm.cancelEdit();
				}
			});
			jQuery('.inlineEditDiv input').focus();
			vm.inlineActive = true;
		}

		function getTextTemplate(position, field, label, customFieldNdx, customFieldType) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (position.left + 296 > windowWidth) {
				position.left = position.left - (position.left + 296 - windowWidth - 8);
			}
			if (position.top + 112 > windowHeight) {
				position.top = position.top - (position.top + 112 - windowHeight - 8);
			}
			var editTemplate = '<div class="inlineEditDiv textEdit" style="top:' + position.top + 'px; left: ' +
				position.left + 'px;"><div class="inlineEditHeader"><span translate>Edit ' + label + '</span></div>' +
				'<div id="errorMsg" style="color:red;" class="hide"></div>' +
				(typeof customFieldType !== 'undefined' && customFieldType == 'CURRENCY' ? vm.currencySymbol : '') +
				'<input class="' + (typeof customFieldType !== 'undefined' && customFieldType == 'CURRENCY' ? 'inlineEditCurrencyInput' : 'inlineEditInput') + '"' +
				' ng-model="generalSectionController.currentText" ' + (typeof customFieldType !== 'undefined' && (customFieldType == 'NUMBER' || customFieldType == 'CURRENCY') ? 'type="number"' : '') + '/>' +
				'<div class="inlineEditButtons"><a class="button flat" ng-click="generalSectionController.cancelEdit()" translate>Cancel</a>' +
				'<a class="button flat colored" ng-click="generalSectionController.saveEditText(\'' + field + '\', \'' + escapeSingleQoute(label) + '\',' + getCustomFieldParams(customFieldNdx, customFieldType) + ')" translate>Save</a></div></div>';
			return editTemplate;
		}

		function getMultiselectTemplate(position, field, fieldId, label, id, display) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (position.left + 680 > windowWidth) {
				position.left = position.left - (position.left + 680 - windowWidth - 8);
			}
			if (position.top + 356 > windowHeight) {
				position.top = position.top - (position.top + 356 - windowHeight - 8);
			}

			var multiSelectStr = 'multiple';
			var uiSelectMatchTerm = '{{$item.name}}';
			var className = 'multiselect-edit';

			var editTemplate = '<div ng-click="$event.preventDefault();" class="inlineEditDiv ' + className + '" style="top:' + position.top + 'px; left: ' + position.left + 'px; width: 680px">' +
				'<div class="inlineEditHeader"><span translate>Choose ' + label + '</span></div>' +
				'<ui-select ' + multiSelectStr + ' append-to-body="true" theme="bootstrap" ng-model="generalSectionController.modelName">' +
				'<ui-select-match placeholder="{{\'' + 'Select ' + label + '...\'' + ' | translate}}">' +
				uiSelectMatchTerm +
				'</ui-select-match>';

			editTemplate += '<ui-select-choices repeat="item.' + id + ' as item  in generalSectionController.dropdownLists.' + field + ' | filter: $select.search">' +
			'<div>{{item.' + display + '}}</div>' +
			'</ui-select-choices>' +
			'</ui-select>';

			editTemplate += '<div class="inlineEditButtons">' +
			'<button class="button flat" ng-click="generalSectionController.cancelEdit()" translate>Cancel</button>' +
			'<button class="button flat colored" ng-click="generalSectionController.saveEditList(\'' + field + '\', \'' + fieldId + '\', \'' + escapeSingleQoute(label) + '\', \'' + id + '\', \'' + display + '\')" translate>Save</button>' +
			'</div>' +
			'</div>';
			return editTemplate;
		}

		function getTextAreaTemplate(position, field, label, customFieldNdx, customFieldType) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			var divHeight = 140;
			var extraClass = '';
			if (field === 'description') {
				divHeight = 348;
				extraClass = ' description-area';
			}
			if (position.left + 296 > windowWidth) {
				position.left = position.left - (position.left + 296 - windowWidth - 8);
			}
			if (position.top + divHeight > windowHeight) {
				position.top = position.top - (position.top + divHeight - windowHeight - 8);
			}
			var editTemplate = '<div class="inlineEditDiv textAreaEdit' + extraClass + '" style="top:' + position.top + 'px; left: ' +
				position.left + 'px;"><div class="inlineEditHeader"><span translate>Edit ' + label + '</span></div>' +
				'<textarea class="inlineEditInput" ng-model="generalSectionController.currentText"></textarea>' +
				'<div class="inlineEditButtons"><a class="button flat" ng-click="generalSectionController.cancelEdit()" translate>Cancel</a>' +
				'<a class="button flat colored" ng-click="generalSectionController.saveEditText(\'' + field + '\', \'' + escapeSingleQoute(label) + '\',' + getCustomFieldParams(customFieldNdx, customFieldType) + ')" translate>Save</a></div></div>';
			return editTemplate;
		}

		function getListTemplate(position, field, fieldId, label, id, display, customFieldNdx, customFieldType, translate, showClear) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (position.left + 340 > windowWidth) {
				position.left = position.left - (position.left + 340 - windowWidth - 8);
			}
			if (position.top + 356 > windowHeight) {
				position.top = position.top - (position.top + 356 - windowHeight - 8);
			}

			var editTemplate = '<div ng-click="$event.preventDefault();" class="inlineEditDiv textEdit" style="top:' + position.top + 'px; left: ' + position.left + 'px;">' +
				'<div class="inlineEditHeader"><span translate>Choose ' + label + '</span></div>' +
				'<ui-select append-to-body="true" theme="bootstrap" ng-model="generalSectionController.currentListOption">' +
				'<ui-select-match placeholder="{{\'' + 'Select ' + escapeSingleQoute(label) + '...\'' + '| translate}}">' +
				'{{$select.selected.' + display + (translate ? ' | translate' : '') + '}}' +
				'</ui-select-match>' +
				'<ui-select-choices repeat="item.' + id + ' as item in generalSectionController.dropdownLists.' + field + ' | filter: $select.search">' +
				'<div>{{item.' + display +  (translate ? ' | translate' : '') + '}}</div>' +
				'</ui-select-choices>' +
				'</ui-select>' +
				(showClear ? '<div class="inlineEditButtonsLeft"><button class="button flat" ng-click="generalSectionController.saveEditList(\'' + field + '\', \'' +  fieldId + '\', \''  + escapeSingleQoute(label) + '\', \'' + id + '\', \'' + display + '\',' + getCustomFieldParams(customFieldNdx, customFieldType) + ', true)">Clear</button></div>' : '') +
				'<div class="inlineEditButtons">' +
				'<button class="button flat" ng-click="generalSectionController.cancelEdit()" translate>Cancel</button>' +
				'<button class="button flat colored" ng-click="generalSectionController.saveEditList(\'' + field + '\', \'' +  fieldId + '\', \''  + escapeSingleQoute(label) + '\', \'' + id + '\', \'' + display + '\',' + getCustomFieldParams(customFieldNdx, customFieldType) + ')" translate>Save</button>' +
				'</div>' +
				'</div>';
			return editTemplate;
		}

		function getDateTemplate(position, field, label, customFieldNdx, customFieldType, showClear) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (position.left + 340 > windowWidth) {
				position.left = position.left - (position.left + 340 - windowWidth - 8);
			}
			if (position.top + 356 > windowHeight) {
				position.top = position.top - (position.top + 356 - windowHeight - 8);
			}
			var editTemplate = '<div class="inlineEditDiv dateEdit" style="top:' + position.top + 'px; left: ' +
				position.left + 'px;"><div class="inlineEditHeader"><span translate>Choose a ' + label + '</span></div>' +
				'<div uib-datepicker ng-model="generalSectionController.currentDate" class="well well-sm"></div>' +
				'<div class="inlineEditButtons">' +
				(showClear ? '<a class="button flat" ng-click="generalSectionController.saveEditDate(' + "'" + field + "'" + ', ' + "'" + label + "'" + ',' + getCustomFieldParams(customFieldNdx, customFieldType) + ', true)">{{\'Clear\' | translate }}</a>' : '') +
				'<a class="button flat" ng-click="generalSectionController.cancelEdit()">{{\'Cancel\' | translate }}</a>' +
				'<a class="button flat colored" ng-click="generalSectionController.saveEditDate(' + "'" + field + "'" + ', ' + "'" + escapeSingleQoute(label) + "'" + ',' + getCustomFieldParams(customFieldNdx, customFieldType) + ')">{{\'Save\' | translate }}</a></div></div>';
			return editTemplate;
		}

		function loadList(type, customFieldNdx) {
			if (vm.dropdownLists[type] && vm.dropdownLists[type].length) {
				return;
			} else {
				if (typeof customFieldNdx !== 'undefined') {
					leanProjectsService.getCustomFieldDropDownList(customFieldNdx).then(function(customDropDownValues) {
						vm.dropdownLists[type] = customDropDownValues;
					});
				}
				else {
					var dropDownData = [];
					switch (type) {
					case 'type':
						editProjectService.getProjectTypes(vm.leanDirFactoryNdx).then(function (types) {
							vm.dropdownLists[type] = types;
						});
						break;
					case 'supplierName':
						editProjectService.getSuppliers(vm.leanDirFactoryNdx).then(function(suppliers) {
							vm.dropdownLists[type] = suppliers;
						});
						break;
					case 'goals':
						getGoals();
						break;
					default:
						dropDownData = [{id: 1, display: 'Yes'},{id: 0, display: 'No'}];
					}
					vm.dropdownLists[type] = dropDownData;
				}
			}
		}

		function saveEditList(field, fieldId, label, id, display, customFieldNdx, customFieldType, isClear) {
			var saveObj = {};
			saveObj.id = vm.projectNdx;
			var tempField = '';
			var changeMade;
			if (customFieldNdx == null) {
				if (field !== 'goals') {
					saveObj[fieldId] = vm.currentListOption;
					tempField = saveObj[fieldId];
					changeMade = tempField != vm.details[fieldId];
				} else {
					saveObj[fieldId] = vm.modelName;
					tempField = saveObj[fieldId];
					changeMade = !_.isEqual(tempField.sort(), vm.details[fieldId].sort());
				}
			} else {
				saveObj['customFieldNdx'] = customFieldNdx;
				saveObj['customValue'] = isClear ? '': vm.currentListOption;
				saveObj['customFieldType'] = customFieldType;
				saveObj['customFieldName'] = label;
				tempField = saveObj['customValue'];
				changeMade = tempField != vm.details[fieldId];
			}			
			if (changeMade) {
				viewProjectsService.saveProject(saveObj, vm.leanDirFactoryNdx, (new Date(vm.details.lastModified)).toUTCString())
					.then(function(response) {
						if (response && response.status && response.status >= 200 && response.status < 400) {
							var updateMessage = (fieldId == 'completeFlag' ? '' : 'Project ');
							$rootScope.$emit('toast', {'message': label + ' was saved successfully', 'success': true});

							if (field === 'completeFlag') {
								$rootScope.$broadcast('projectValidatedChanged', {projectId: vm.projectNdx, completeFlag: vm.currentListOption});
							}

							if (field !== 'goals') {
								angular.forEach(vm.dropdownLists[field], function(obj) {
									if (obj[id] === vm.currentListOption) {
										vm.details[field] = obj[display];
									}
								});
								vm.details[fieldId] = isClear ? null: vm.currentListOption;
							} else {
								updateGoalModelAfterSave();
							}
							vm.currentListOption = '';
							$scope.$emit('updateLastModified');
							$rootScope.$emit('activityUpdated');
						} else if (response && response.status === 412) {
							var errorMessage = 'This project has been updated since you last loaded the page, please refresh the page';
							if (response && response.data && response.data.error) {
								errorMessage = response.data.error;
							}
							$rootScope.$emit('toast', {'message': errorMessage, 'success': false});
						} else {
							$rootScope.$emit('toast', {'message': 'Unexpected server error', 'success': false});
						}
					});
			}
			cancelEdit();
		}

		function saveEditText(field, label, customFieldNdx, customFieldType) {
			var saveObj = {};
			saveObj.id = vm.projectNdx;
			var tempField = '';
			if (customFieldNdx == null) {
				saveObj[field] = vm.currentText;
				tempField = saveObj[field];
			} else {
				saveObj['customFieldNdx'] = customFieldNdx;
				saveObj['customValue'] = vm.currentText == null ? '' : vm.currentText;
				saveObj['customFieldType'] = customFieldType;
				saveObj['customFieldName'] = label;
				tempField = saveObj['customValue'];
				if ((customFieldType == 'NUMBER' || customFieldType == 'CURRENCY') && isNaN(vm.currentText)) {
					jQuery('.inlineEditDiv.textEdit').height(115);
					jQuery('#errorMsg').text('Only numeric value is allowed').removeClass('hide');
					return false;
				}
			}
			if (tempField != vm.details[field]) {
				viewProjectsService.saveProject(saveObj, vm.leanDirFactoryNdx, (new Date(vm.details.lastModified)).toUTCString())
					.then(function(response) {
						if (response && response.status && response.status >= 200 && response.status < 400) {
							$rootScope.$emit('toast', {'message': 'Project ' + label + ' was saved successfully', 'success': true});
							vm.details[field] =  strip(vm.currentText);
							vm.currentText = '';
							$scope.$emit('updateLastModified');
							$rootScope.$emit('activityUpdated');
						} else if (response && response.status === 412) {
							var errorMessage = 'This project has been updated since you last loaded the page, please refresh the page';
							if (response && response.data && response.data.error) {
								errorMessage = response.data.error;
							}
							$rootScope.$emit('toast', {'message': errorMessage, 'success': false});
						} else {
							$rootScope.$emit('toast', {'message': 'Unexpected server error', 'success': false});
						}
					});
			}
			cancelEdit();
		}

		function saveEditDate(field, label, customFieldNdx, customFieldType, clear) {
			var saveObj = {};
			saveObj.id = vm.projectNdx;

			var currentDateUtc = '';
			if (!clear) {
				currentDateUtc = moment(vm.currentDate).subtract(vm.currentDate.getTimezoneOffset(), 'minutes');
				vm.currentDate = moment(vm.currentDate)._d;
				currentDateUtc = moment(currentDateUtc)._d;
			} else {
				vm.currentDate = '';
			}
			
			var tempField = '';
			if (customFieldNdx == null) {
				saveObj[field] = currentDateUtc;
				tempField = saveObj[field];
			} else {
				saveObj['customFieldNdx'] = customFieldNdx;
				saveObj['customDateValue'] = currentDateUtc;
				saveObj['customFieldType'] = customFieldType;
				saveObj['customFieldName'] = label;
				tempField = saveObj['customDateValue'];
			}
			if (tempField != vm.details[field]) {
				viewProjectsService.saveProject(saveObj, vm.leanDirFactoryNdx, (new Date(vm.details.lastModified)).toUTCString())
					.then(function(response) {
						if (response && response.status && response.status >= 200 && response.status < 400) {
							$rootScope.$emit('toast', {'message': 'Project ' + label + ' was saved successfully', 'success': true});
							vm.details[field] = vm.currentDate;
							vm.currentDate = '';
							$scope.$emit('updateLastModified');
							$rootScope.$emit('activityUpdated');
						} else if (response && response.status === 412) {
							var errorMessage = 'This project has been updated since you last loaded the page, please refresh the page';
							if (response && response.data && response.data.error) {
								errorMessage = response.data.error;
							}
							$rootScope.$emit('toast', {'message': errorMessage, 'success': false});
						} else {
							$rootScope.$emit('toast', {'message': 'Unexpected server error', 'success': false});
						}
					});
			}
			cancelEdit();
		}

		function cancelEdit() {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			if ($scope.$$childTail.$selectMultiple) {
				// destroy multiselects if exists
				delete $scope.$$childTail.$select;
				delete $scope.$$childTail.$selectMultiple;
			}
			vm.inlineActive = false;
		}

		function getCustomFieldParams(customFieldNdx, customFieldType) {
			if(customFieldNdx) {
				return customFieldNdx + ',\'' + customFieldType + '\'';
			}
			return 'null,null';
		}

		function updateGoalModel() {
			vm.details.goalNames = '';
			vm.details.goalIds = [];
			angular.forEach(vm.details.goals, function(goal) {
				vm.details.goalNames += strip(goal.name) + ', ';
				vm.details.goalIds.push(goal.id);
			});
			if (vm.details.goalNames.length > 2) {
				vm.details.goalNames =  vm.details.goalNames.substring(0, vm.details.goalNames.length - 2);
			}
		}

		function updateGoalModelAfterSave() {
			vm.details.goalIds = vm.modelName;
			vm.modelName = undefined;
			var goals = [];
			for (var i = 0; i < vm.details.goalIds.length; i++) {
				var goalIndex = findInArray(vm.dropdownLists.goals, 'id', vm.details.goalIds[i]);
				if (goalIndex || goalIndex == 0) {
					goals.push(vm.dropdownLists.goals[goalIndex]);
				}
			}
			vm.details.goals = goals;
			updateGoalModel();
		}

		function getGoals() {
			editProjectService.getGoals(vm.leanDirFactoryNdx).then(function (goals) {
				vm.dropdownLists['goals'] = goals || [];
    		vm.noGoalsDefined = !vm.dropdownLists['goals'].length;
			});
		}
	}

})();
